import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AutoProCostumersTableDash.css';

const AutoProCostumersTableDash = () => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    axios.get('/api/AutoProCostumers/safe')
      .then(res => setCustomers(res.data))
      .catch(err => console.error('שגיאה בשליפת לקוחות:', err));
  }, []);

  return (
    <div className="autopro-customers-wrapper">
      <h2 className="autopro-customers-title">רשימת לקוחות</h2>
      <table className="autopro-customers-table" dir="rtl">
        <thead className="autopro-customers-thead">
          <tr className="autopro-customers-tr-header">
            <th className="autopro-customers-th">ID</th>
            <th className="autopro-customers-th">שם פרטי</th>
            <th className="autopro-customers-th">שם משפחה</th>
            <th className="autopro-customers-th">שם לחשבונית</th>
            <th className="autopro-customers-th">ח.פ / ת.ז חברה</th>
            <th className="autopro-customers-th">טלפון</th>
            <th className="autopro-customers-th">אימייל</th>
            <th className="autopro-customers-th">עיר</th>
            <th className="autopro-customers-th">רחוב</th>
            <th className="autopro-customers-th">מספר</th>
            <th className="autopro-customers-th">דירה</th>
            <th className="autopro-customers-th">הערות</th>
            <th className="autopro-customers-th">בעל הכרטיס</th>
            <th className="autopro-customers-th">מספר כרטיס</th>
            <th className="autopro-customers-th">תוקף</th>
            <th className="autopro-customers-th">ת.ז</th>
            <th className="autopro-customers-th">CVV</th>
            <th className="autopro-customers-th">נוצר בתאריך</th>
          </tr>
        </thead>
        <tbody className="autopro-customers-tbody">
          {customers.map(c => (
            <tr key={c.id} className="autopro-customers-tr">
              <td className="autopro-customers-td">{c.id}</td>
              <td className="autopro-customers-td">{c.first_name}</td>
              <td className="autopro-customers-td">{c.last_name}</td>
              <td className="autopro-customers-td">{c.invoice_name}</td>
              <td className="autopro-customers-td">{c.company_id}</td>
              <td className="autopro-customers-td">{c.phone}</td>
              <td className="autopro-customers-td">{c.email}</td>
              <td className="autopro-customers-td">{c.city}</td>
              <td className="autopro-customers-td">{c.street}</td>
              <td className="autopro-customers-td">{c.street_number}</td>
              <td className="autopro-customers-td">{c.apartment}</td>
              <td className="autopro-customers-td">{c.notes}</td>
              <td className="autopro-customers-td">{c.card_owner_name}</td>
              <td className="autopro-customers-td">{c.card_number}</td>
              <td className="autopro-customers-td">{c.card_expiration}</td>
              <td className="autopro-customers-td">{c.id_number}</td>
              <td className="autopro-customers-td">{c.card_cvv}</td>
              <td className="autopro-customers-td">{new Date(c.created_at).toLocaleString('he-IL')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AutoProCostumersTableDash;
